module.exports = __webpack_public_path__ + "img/PhoneTag_EGM.fa99ff71.png";